export const isCrmSection = submodule => {
  const submodules = ['accounts', 'opportunities', 'contacts', 'leads']

  return !!submodules.includes(submodule)
}

export const getRouteView = module => {
  if (module === 'accounts') return 'account-view'
  if (module === 'opportunities') return 'opportunity-view'
  if (module === 'contacts') return 'contact-view'

  return 'lead-view'
}
